import { PATHS } from '@belong/common';
import { Image, Button, Text, LinkBase } from '@belong/ui';
import clsx from 'clsx';
import css from './guaranteed-rent-with-belong-x-card.module.css';
import { GUARANTEED_RENT_WITH_BELONG_X_STRINGS as STRINGS } from './guaranteed-rent-with-belong-x-card.strings';

export const GuaranteedRentWithBelongXCard = () => {
  return (
    <div className="container">
      <LinkBase href={PATHS.BELONG_X}>
        <div className="border-green bg-green-translucent-light pl-lg pr-2xs pt-2sm flex cursor-pointer flex-col justify-center rounded border border-solid">
          <div className="hidden items-center md:flex md:justify-between">
            <div className="flex flex-col items-start">
              <Text fontWeight="semibold">
                {STRINGS['guarantedRentWithBelongXSection.topText']}
              </Text>
              <div className="gap-xs items-center lg:flex">
                <Text
                  variant="h2"
                  fontWeight="semibold"
                  className="text-h2-xl inline self-center"
                >
                  {STRINGS['guarantedRentWithBelongXSection.title']}
                </Text>
                <Image
                  src="/modals/how_it_works/belong_x_logo_navy.png"
                  className={clsx(css.belongXLogoDesktop)}
                  alt=""
                  aria-hidden="true"
                />
              </div>
              <div>
                <Button
                  variant="text"
                  buttonType="secondary"
                  size="auto"
                  onClick={() => {}}
                >
                  {STRINGS['guarantedRentWithBelongXSection.cta']}
                </Button>
              </div>
            </div>
            <Image
              src="belong-x/lp_pro_x_img 2.png"
              alt=""
              aria-hidden="true"
              className={css.cellphonesImageDesktop}
            />
          </div>

          <div className="relative flex flex-col md:hidden">
            <Text variant="p1">
              {STRINGS['guarantedRentWithBelongXSection.topText']}
            </Text>
            <div className="flex justify-between">
              <div>
                <Text fontWeight="semibold" className="inline">
                  {STRINGS['guarantedRentWithBelongXSection.title']}
                </Text>
                <Image
                  src="belong-x/logo_belong_x_mobile.svg"
                  className={clsx(
                    css.belongXLogoMobile,
                    '-mb-2xs ml-2xs inline',
                  )}
                  alt=""
                  aria-hidden="true"
                />
                <div>
                  <Button
                    variant="text"
                    buttonType="secondary"
                    size="auto"
                    onClick={() => {}}
                  >
                    {STRINGS['guarantedRentWithBelongXSection.cta']}
                  </Button>
                </div>
              </div>
              <Image
                src="belong-x/lp_pro_x_img.png"
                alt=""
                aria-hidden="true"
                className={css.cellphonesImageMobile}
              />
            </div>
          </div>
        </div>
      </LinkBase>
    </div>
  );
};
